
export interface Faq {
  question: string
  answer: string
}

export const faqs: Faq[] = [
  {
    question: '¿Necesito experiencia previa o mano artística?',
    answer:
      'No. La forma la pone la flor: tu trabajo es elegirla, aplicarle el método que le corresponde y respetar los tiempos. Los 10 proyectos están ordenados de más simple a más elaborado, así que empezás por un marcapáginas y llegás al cuadro herbario cuando quieras.',
  },
  {
    question: '¿Cuánto tarda en dar resultado la técnica?',
    answer:
      'Depende de la flor y del método. Hay métodos que dejan una flor lista en unas horas y otros que piden entre una y tres semanas de secado. La guía indica el tiempo estimado de cada uno para que planifiques según lo que querés hacer, y cómo revisar el avance sin arruinar la pieza.',
  },
  {
    question: '¿Sirve si quiero vender mis creaciones, no solo hacerlo de hobby?',
    answer:
      'Sí. Hay proyectos pensados para eso: piezas de alto valor percibido con materiales de bajo costo, más el calendario estacional para juntar material a tiempo, el registro de seguimiento para producir varias piezas en paralelo y el diccionario de flores para armar series con concepto.',
  },
  {
    question: '¿En qué formato recibo la guía y cómo accedo?',
    answer:
      'Es una guía digital en PDF de más de 50 páginas, con los 4 bonus incluidos. Después de la compra recibís el acceso por mail de forma inmediata. La podés leer en el celular, la computadora o la tablet, e imprimir las páginas del kit de herbario cuando las necesites.',
  },
]
